import React, { useState } from "react";
import Modal from "react-modal";
import Sheet from "react-modal-sheet";
import XButton from "assets/icons/x_button.svg";
import { TextButton } from "kubra-ux-forge";
import { Outlet, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import {
  COMMON_NAMESPACE,
  LANGUAGE_MODAL_NAMESPACE,
  MENU_NAMESPACE,
} from "constants/i18n-namespaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/pro-solid-svg-icons";
import { ENGLISH, FRENCH, SPANISH } from "kubra-labels";
import routing from "routing";
import { customStyles } from "constants/customStyles";
import { LanguageModal } from "../language-modal";
import { faSignOut } from "@fortawesome/pro-regular-svg-icons";
import { setAppLoading } from "actions/appStateActions";
import { useDispatch, useSelector } from "react-redux";
import { PageLoader } from "components/ezpay/common/page-loader";
import { getPayableSession } from "selectors/payableSession";
import { setPayableSession } from "actions/payableSessionActions";
import IamApi from "api/IamApi";
import { USER_LOGOUT } from "actions/userActions";
import { StyledLanguageMobileButton } from "../menu/styled-components";

export const PayableHeader = (props: any) => {
  const payableSession = useSelector(getPayableSession);
  const { t, i18n } = useTranslation();
  const [languageModalDisplay, setLanguageModalDisplay] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogoutClick = async () => {
    dispatch(setAppLoading(true));
    dispatch({ type: USER_LOGOUT });
    dispatch(setPayableSession(undefined));
    IamApi.ezpay.logout();
    navigate(routing.index());
  };

  const closeLanguagesModal = () => {
    setLanguageModalDisplay(false);
  };

  const getLanguageDisplayValue = (language: string) => {
    switch (language) {
      case ENGLISH:
        return t("eng", { ns: MENU_NAMESPACE });
      case SPANISH:
        return t("spa", { ns: MENU_NAMESPACE });
      case FRENCH:
        return t("fre", { ns: MENU_NAMESPACE });
      default:
        return t("eng", { ns: MENU_NAMESPACE });
    }
  };

  return (
    <>
      <PageLoader />
      <div>
        {!props.isMobile && (
          <TextButton
            // @ts-ignore
            icon={<FontAwesomeIcon icon={faGlobe} />}
            onClick={() => {
              setLanguageModalDisplay(true);
            }}
            dataCy="button-language"
          >
            {getLanguageDisplayValue(i18n.language)}
          </TextButton>
        )}
        {props.isMobile && (
          <StyledLanguageMobileButton
            // @ts-ignore
            icon={<FontAwesomeIcon icon={faGlobe} />}
            onClick={() => {
              setLanguageModalDisplay(true);
            }}
            dataCy="button-language"
          >
            {getLanguageDisplayValue(i18n.language)}
          </StyledLanguageMobileButton>
        )}
        {payableSession?.payable?.category?.toLowerCase() === "account" &&
          !props.isMobile &&
          payableSession?.channel !== "CallCenter" && (
            <TextButton
              icon={<FontAwesomeIcon icon={faSignOut} />}
              onClick={() => handleLogoutClick()}
              dataCy="button-logout"
            >
              {t("change-account", { ns: MENU_NAMESPACE })}
            </TextButton>
          )}
        {payableSession?.payable?.category?.toLowerCase() === "account" &&
          props.isMobile &&
          payableSession?.channel !== "CallCenter" && (
            <TextButton
              icon={<FontAwesomeIcon icon={faSignOut} />}
              onClick={() => handleLogoutClick()}
              dataCy="button-logout"
              style={{ padding: "0px 1.2rem" }}
            >
              {""}
            </TextButton>
          )}
      </div>

      {/* language modal and sheet */}
      {props.isMobile && (
        <Sheet
          isOpen={languageModalDisplay}
          onClose={closeLanguagesModal}
          disableDrag={true}
          detent="content-height"
        >
          <Sheet.Container>
            <Sheet.Header>
              <div className="react-modal-sheet-header">
                <div className="help-modal-header-text">
                  {t("header", { ns: LANGUAGE_MODAL_NAMESPACE })}
                </div>
                <button
                  className="modal-close"
                  onClick={closeLanguagesModal}
                  data-cy="modal-close-x-language"
                >
                  <img
                    src={XButton}
                    alt={`${t("close-modal", { ns: COMMON_NAMESPACE })}`}
                    className="modal-close-x"
                  />
                </button>
              </div>
            </Sheet.Header>
            <Sheet.Content>
              <LanguageModal onClose={closeLanguagesModal} />
            </Sheet.Content>
          </Sheet.Container>
          {/* @ts-ignore */}
          <Sheet.Backdrop onClick={closeLanguagesModal} />
        </Sheet>
      )}
      {!props.isMobile && (
        // @ts-ignore
        <Modal
          isOpen={languageModalDisplay}
          ariaHideApp={false}
          className="modal-frame-help"
          shouldCloseOnOverlayClick={true}
          onRequestClose={closeLanguagesModal}
          style={customStyles}
        >
          <div className="modal-header">
            <div className="help-modal-header-text">
              {t("header", { ns: LANGUAGE_MODAL_NAMESPACE })}
            </div>
            <button
              className="modal-close"
              onClick={closeLanguagesModal}
              data-cy="modal-close-x-help"
            >
              <img
                src={XButton}
                alt={`${t("close-modal", { ns: COMMON_NAMESPACE })}`}
                className="modal-close-x"
              />
            </button>
          </div>
          <LanguageModal onClose={closeLanguagesModal} />
        </Modal>
      )}
      <Outlet context={payableSession} />
    </>
  );
};
